<template>
  <div
    class="container"
    :class="{'cover':!$store.getters.ambientType}"
  >
    <div
      class="content"
      v-if="orderList.length != 0"
    >
      <van-swipe
        class="swipe"
        @change="onChange"
      >
        <van-swipe-item
          v-for="(item,index) in orderList"
          :key="index"
        >
          <div class="order-wl">
            <div class="wl-common van-hairline--bottom">
              <span>提货人</span>
              <span>{{item.buyerName}}<b>{{item.buyerMobile}}</b></span>
            </div>
            <div class="wl-common">
              <span style="visibility: hidden">提货人地址</span>
              <span class="van-multi-ellipsis--l3">{{item.scType == 2 ? `${item.schooleName}${item.gradeName}${item.className}` : item.buyerAddress}}</span>
            </div>
          </div>
          <div class="order-goods">
            <div class="order-head van-hairline--bottom">
              <div class="shop-img">
                <img
                  :src="imgPrex + item.sellerImageLogo"
                  alt
                />
              </div>
              <div class="shop-title">
                <div class="shop-name">
                  <span class="van-ellipsis">{{ item.sellerName }}</span>
                </div>
                <div class="shop-time">{{ item.createTime }}</div>
              </div>
              <div class="order-state">
                已发货
              </div>
            </div>
            <div
              class="goods-item"
              v-for="(item,index) in item.ordersProduct"
              :key="index"
            >
              <div class="good-img">
                <img
                  :src="imgPrex+item.imageUrl"
                  alt
                />
                <span v-show="item.refundState == 1 || item.refundState == 3">{{item.refundState == 1?"退款中":"已退款"}}</span>
              </div>
              <div class="good-cont">
                <div class="goods-name van-ellipsis">{{item.productName}}</div>
                <div class="goods-specs">{{item.normList | toNormList}}</div>
                <div class="goods-count">x{{parseInt(item.count)}}</div>
              </div>
            </div>
            <div class="goods-line van-hairline--top"></div>
            <div
              class="order-info"
              v-show="item.note"
            >
              <span>订单备注</span>
              <span class="van-multi-ellipsis--l3">{{item.note}}</span>
            </div>
          </div>
        </van-swipe-item>
        <template #indicator>
          <div class="custom-indicators">
            <i
              class="custom-indicator"
              :class="{'custom-indicator-acvitce':current==index}"
              v-for="(item,index) in orderList.length"
              :key="index"
            ></i>
          </div>
        </template>
      </van-swipe>
      <van-button
        class="btn"
        text="确认提货"
        block
        @click="submit"
      />
    </div>
    <div
      class="notHave"
      v-else
    >
      <i class="iconfont icon-personal_image_nosto1"></i>
      <p>暂无可提货订单</p>
    </div>
  </div>
</template>

<script>
import { scanPickUpGoods, confirmReceipt } from "@/api/join";
export default {
  data() {
    return {
      orderList: [],
      current: 0,
    };
  },
  filters: {
    toNormList(val) {
      if (val.length) {
        let list = val.map(function (obj) {
          return obj.attr
        })
        return list.join(" / ")
      }
    }
  },
  methods: {
    onChange(index) {
      this.current = index;
    },
    submit() {
      this.$dialog.alert({
        message: "确认用户提货了吗",
        confirmButtonText: "确定提货",
        confirmButtonColor: "#1993FF",
        cancelButtonText: "还未提货",
        cancelButtonColor: "#1D1D1D",
        showCancelButton: true,
      })
        .then(() => {
          confirmReceipt({
            orderId: this.orderList[this.current].orderId
          }).then((res) => {
            if (res.appStatus.errorCode == 0) {
              this.orderList.splice(this.current, 1); // 删除数组导致下标错位
              this.orderList.length == this.current ? this.current = this.current - 1 : this.current; // 修复错位
            }
          });
        });
    },
  },
  mounted() {
    scanPickUpGoods({
      page: {
        way: "0", // 0:不分页 后台最多返回999条数据 1:分页
        index: "1", // 请求页数，index = 1 表示第一页
        size: "100", //数量
      },
      buyerMemberId: this.GetQueryString("memberId").split("isBoss")[0],
    }).then((res) => {
      if (res.appStatus.errorCode == 0) {
        this.orderList = res.content.orderList;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.container {
  height: calc(100% - 149px);
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  .content {
    flex: 1;
    .swipe {
      height: 100%;
    }
  }
}
.cover {
  height: calc(100% - 105px);
}
.order-wl,
.order-goods {
  padding: 0 15px;
  background-color: #ffffff;
}
.order-goods {
  margin-top: 10px;
  .order-head {
    height: 40px;
    line-height: 20px;
    padding: 5px 0;
    display: flex;
    .shop-img {
      flex: 0 0 40px;
      height: 40px;
      border-radius: 5px;
      overflow: hidden;
      margin-right: 8px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .shop-title {
      flex: 1;
      overflow: hidden;
      .shop-name {
        flex: 1;
        span {
          max-width: 210px;
          font-size: 16px;
          font-weight: 800;
          display: inline-block;
          position: relative;
        }
      }
      .shop-time {
        font-size: 12px;
        color: #8d8d8d;
      }
    }
    .order-state {
      flex-shrink: 0;
      font-size: 16px;
      color: #ff1310;
    }
  }
}
.wl-common,
.order-info {
  display: flex;
  justify-content: space-between;
  padding: 15px 0;
  font-size: 15px;
  span:first-of-type {
    flex: 0 0 100px;
    color: #8d8d8d;
  }
}
.wl-common {
  b {
    margin-left: 10px;
    font-weight: 400;
  }
}
.goods-item {
  display: flex;
  padding: 10px 0;
  .good-img {
    width: 84px;
    height: 84px;
    margin-right: 10px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    span {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      padding: 1px 0;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      background-color: rgba(0, 0, 0, 0.5);
    }
  }
  .good-cont {
    flex: 1;
    position: relative;
    overflow: hidden;
    .goods-name {
      font-size: 14px;
      font-weight: 800;
    }
    .goods-specs {
      margin-top: 2px;
      font-size: 12px;
      color: #999999;
    }
    .goods-count {
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      font-size: 12px;
      color: #999999;
    }
  }
}
.goods-line {
  height: 10px;
}
.order-info {
  padding-bottom: 10px;
}
.btn {
  width: 355px;
  height: 50px;
  position: fixed;
  left: 10px;
  bottom: 10px;
  background-color: #50BE4C;
  font-size: 19px;
  color: #ffffff;
  border-radius: 25px;
  z-index: 1000;
}
.custom-indicators {
  position: fixed;
  left: 50%;
  bottom: 70px;
  transform: translateX(-50%);
  .custom-indicator {
    width: 6px;
    height: 6px;
    display: inline-block;
    background-color: #f5f5f5;
    border: 1px solid #b4b4b4;
    border-radius: 50%;
    box-sizing: border-box;
  }
  .custom-indicator-acvitce {
    border: none;
    background-color: #ff1310;
  }
  .custom-indicator:not(:last-child) {
    margin-right: 4px;
  }
}
.notHave {
  margin-top: 178px;
  text-align: center;
  i {
    font-size: 107px;
    color: #d5d5d7;
  }
  p {
    font-size: 15px;
    color: #a3a2a2;
    margin-top: 32px;
  }
}
</style>